import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";

export const Container = styled.div`
  width: 100%;
  padding: ${() => `${viewSizeCalculator(0.625)}`}; // 0.625rem;

  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(1.25)}`}; // 1rem;

  border-radius: ${() => `${viewSizeCalculator(0.625)}`}; // 0.625rem;

  background-color: ${({ collapsed }) => !collapsed && "#fbfbfb"};

  &:hover {
    background-color: #fbfbfb;
    cursor: pointer;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${() => `${viewSizeCalculator(0.7)}`}; // 0.7rem;
  cursor: pointer;
`;

export const CallToActionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${() => `${viewSizeCalculator(0.75)}`}; // 0.75rem;

  ${({ isBookmarked, isCompared }) => (isBookmarked || isCompared) && `opacity: 1; visibility: visible;`}

  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;

  svg {
    width: ${() => `${viewSizeCalculator(1.5)}`};
    height: ${() => `${viewSizeCalculator(1.5)}`};
  }
  cursor: pointer;
`;

export const ArrowIcon = styled.span`
  width: ${() => `${viewSizeCalculator(0.75)}`}; // 1rem;
  height: ${() => `${viewSizeCalculator(1.2)}`}; // 1rem;
  display:flex;
  align-items:center;
  justify-content:center;
  transform: ${(props) => (props.collapsed ? "rotate(0deg)" : "rotate(90deg)")};
  transition: transform 0.2s ease-in-out;
  svg {
    width: ${() => `${viewSizeCalculator(0.75)}`}; // 1rem;
    height: ${() => `${viewSizeCalculator(0.75)}`}; // 1rem;
  }
`;

export const Title = styled.h2`
  margin: 0;
  font-size: ${() => `${viewSizeCalculator(1)}`};
  font-weight: ${(props) => (props?.collapsed ? 500 : 700)};
  color: #333333;
  text-transform: capitalize;

  display: flex;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.35)}`};

  &:hover {
    color: #e35b42;
  }

  ${(props) =>
    props.showHover &&
    `
      color: #E35B42; /* Change color on hover */

      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    `}
`;

export const PartnerLocationIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: ${() => `${viewSizeCalculator(1)}`};
    height: ${() => `${viewSizeCalculator(1)}`};
    display: block;
  }
`;

export const SubTitle = styled.p`
  margin: ${() => `${viewSizeCalculator(0.25)} 0 0`}; // 0.25rem 0 0;
  color: #333333;
  opacity: 60%;
  font-size: ${() => `${viewSizeCalculator(0.8125)}`}; // 0.8125rem;
  font-weight: 500;
  // text-transform: capitalize;
`;

export const Span = styled.span`
  color: #000000;
  font-weight: 700;
`

export const SubTitleBold = styled.p`
  margin: ${() => `${viewSizeCalculator(0.25)} 0 0`}; // 0.25rem 0 0;
  color:#000000;
  opacity: 60%;
  font-size: ${() => `${viewSizeCalculator(0.8125)}`}; 
  font-weight: 700;
  // text-transform: capitalize;
`

export const DetailsSection = styled.div`
  display: flex;
  align-items: center;

  gap: ${() => `${viewSizeCalculator(3.75)}`}; // 3.75rem;

  margin: ${() => `0 ${viewSizeCalculator(1.7)}`}; // 1rem;

  height: ${({ collapsed }) =>
    collapsed ? "0px" : "auto"}; // Large enough height
  opacity: ${({ collapsed }) => (collapsed ? "0" : "1")};
  overflow: hidden;
  transition:
    max-height 0.6s ease-out,
    opacity 0.6s ease-out;
  position: ${({ collapsed }) => (collapsed ? "absolute" : "relative")};
`;

export const DetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  gap: ${() => `${viewSizeCalculator(1)}`}; // 1rem;
`;

export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;

  gap: ${() => `${viewSizeCalculator(1)}`}; // 1rem;

  svg {
    width: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem;
    height: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem;
  }
`;

export const ContentTitle = styled.div`
  font-size: ${() => `${viewSizeCalculator(0.8125)}`}; // 0.8125rem;
  font-weight: 600;
`;

export const CompareIconWrapper = styled.div`
  visibility: ${({ isCompared }) => (isCompared ? "visible" : "hidden")};;
  ${Container}:hover & {
    visibility: visible;
  }

  visibility: ${({ collapsed }) => (!collapsed ? "visible" : "none")};
`;

export const OpenNewTabIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: ${() => `${viewSizeCalculator(0.125)}`};

  visibility: hidden;
  ${Container}:hover & {
    visibility: visible;
  }

  svg {
    width: ${() => `${viewSizeCalculator(1.25)}`};
    height: ${() => `${viewSizeCalculator(1.25)}`};
  }

  visibility: ${({ collapsed }) => (!collapsed ? "visible" : "none")};
`;

export const BookmarkIconWrapper = styled.div`
  visibility: ${({ loading, isBookmarked }) => (loading || isBookmarked ? "visible" : "hidden")};
  ${Container}:hover & {
    visibility: visible;
  }

  visibility: ${({ loading, collapsed }) => (loading || !collapsed ? "visible" : "none")};
`;

export const ListViewSkeletonContainer = styled.div`
  width: 100%;
  padding: ${viewSizeCalculator(0.645)} ${viewSizeCalculator(0.245)};
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(2.35)}`};
`;
